import React, { createContext, useContext, useState, useEffect } from "react";
import { CursorType } from "../config/cursorConfig";

interface CursorContextType {
  activeCursor: CursorType | null;
  setActiveCursor: (cursor: CursorType | null) => void;
}

const CursorContext = createContext<CursorContextType | undefined>(undefined);

export const CursorProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [activeCursor, setActiveCursor] = useState<CursorType | null>(null);

  // Listen for Escape key to reset cursor to default
  useEffect(() => {
    const handleEscapeKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") {
        setActiveCursor(null);
        // Also reset cursor style on canvas elements immediately
        const canvases = document.querySelectorAll("canvas");
        canvases.forEach((canvas) => {
          (canvas as HTMLElement).style.cursor = "auto";
        });
      }
    };
    window.addEventListener("keydown", handleEscapeKey);
    return () => window.removeEventListener("keydown", handleEscapeKey);
  }, []);

  return (
    <CursorContext.Provider value={{ activeCursor, setActiveCursor }}>
      {children}
    </CursorContext.Provider>
  );
};

export const useCursor = (): CursorContextType => {
  const context = useContext(CursorContext);
  if (!context) {
    throw new Error("useCursor must be used within CursorProvider");
  }
  return context;
};
